export default {
  timeFormats: {
    DATE: "Genauer Datumsbereich",
    TODAY: "Heute",
    YESTERDAY: "Gestern",
    LAST_7: "Letzte 7 Tage",
    LAST_30: "Letzte 30 Tage",
    THIS_MONTH: "Dieser Monat",
    LAST_MONTH: "Letzter Monat",
    THIS_YEAR: "Dieses Jahr",
    LAST_YEAR: "Letztes Jahr"
  },
  BF2: "BF2",
  BF3: "BF3",
  BF3_PLUS: "BF3+",
  BF4: "BF4",
  VLM: "VLM",
  KRS_CDiG: "CEIDG",
  FILE: "Datei"
};
